import { render, staticRenderFns } from "./SearchModal.vue?vue&type=template&id=56323f4f&scoped=true"
import script from "./SearchModal.vue?vue&type=script&lang=js"
export * from "./SearchModal.vue?vue&type=script&lang=js"
import style0 from "./SearchModal.vue?vue&type=style&index=0&id=56323f4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56323f4f",
  null
  
)

export default component.exports